import { ListItem } from "./models/models";

const retrieveNestedValue = (item: ListItem, nestedPath: string): unknown => {
  const splitted = nestedPath.split(".");

  let value = item[splitted[0]];

  for (let i = 1; i < splitted.length; i++) {
    if (!value) {
      break;
    }
    value = value[splitted[i]];
  }

  return value;
};

export const addItemsIfChartValueIsArray = (item: ListItem, options: { chartValueFieldName: string; chartCategoryFieldName: string }): [string, unknown][] => {
  const value = retrieveNestedValue(item, options.chartValueFieldName);
  const category = retrieveNestedValue(item, options.chartCategoryFieldName) as string;

  if (Array.isArray(value)) {
    // example:
    // Show me: OKRs | Horizontal axis: OKR | Values: Owners | Aggregation: Count
    // we store owners like array and we have only 1 row for an okr even if it has more than one owners,
    // so for each owner we need to add additional row so the aggregation is applied correctly
    return value.map((x) => [category, x]);
  }

  return [[category, value]];
};
